import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "course-class-creation",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-class-creation" */ "./components"),
      import(
        /* webpackChunkName: "course-class-creation" */ "./modules/CourseClassCreationModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const key = importedModule1.NAME;
      injectReducer(store, {
        key,
        reducer,
      });
      return component;
    })
  ),
});
